import Swiper from "swiper";
import {Navigation, Pagination, Autoplay} from "swiper/modules";

export const sliderHomeHero = (slider: HTMLElement) => {
    new Swiper(slider, {
        modules: [Navigation, Pagination, Autoplay],
        pagination: {
            el: slider.querySelector('.swiper-pagination') as HTMLElement,
            clickable: true,
        },

        navigation: {
            nextEl: slider.querySelector('.swiper-button-next') as HTMLElement,
            prevEl: slider.querySelector('.swiper-button-prev') as HTMLElement,
        },

        // Configs
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 10000,
        }
    })
}
